


















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Project } from '../types'
import { RawLocation } from 'vue-router'
import ProjectTitleElements from './ProjectTitleElements.vue'

@Component({ components: { ProjectTitleElements } })
export default class extends Vue {
  slideInActive = false

  clicked() {
    // const params = { projectKey: this.project.projectKey }
    // const location: RawLocation = { name: 'project', params}

    if (this.project.slideIn) {
      this.slideInActive = !this.slideInActive
    } else if (this.project.details) {
      this.$store.commit('SET_PROJECT', this.project)
      // this.$router.push(`project/${this.project.projectKey}`)
    }
  }

  openTab(url: string) {
    window.open(url, '_blank')
  }

  get highlight() {
    return this.project.details || this.project.slideIn
  }

  get imageSrc() {
    return this.project.details && this.project.details.projectKey
      ? `/img/projectCard/${this.project.details.projectKey}.jpg`
      : '/img/empty.png'
  }

  @Prop()
  aspectRatio!: number

  @Prop()
  nameSize!: string

  @Prop()
  showRole!: boolean

  @Prop()
  public project!: Project
}
